<template lang="pug">
div.field.is-fullwidth
  .control
    .select.is-fullwidth
      select(v-model="selected")
          option(v-for="cmp of companies", :value="cmp") {{cmp.name}}

</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CompanyPicker",

  computed: {
    ...mapState(["company", "companies"]),
    selected: {
      get() {
        return this.$store.state.company;
      },
      set(value) {
        this.$store.commit("company", value);
      }
    }
  },
  props: {}
};
</script>

<style scoped lang="less">
</style>